// ══════════════════════════════════════════════════════
//  extractors/verdict.js — Verdict 数据提取
//
//  这是 services/verdict.js 的薄包装，把 computeVerdict() 的输出
//  归一化成 extractor 合约（null 或 object，无 NaN）。
//
//  自身不做规则计算，全部委派给 services/verdict.js — 真相源唯一。
// ══════════════════════════════════════════════════════

import { computeVerdict } from '../../services/verdict';
import { calcIRR, alphaScore } from '../../utils/scoring';
import { safeNum } from './_shared';

export function isAvailable(project, a) {
  return !!a;
}

/** project + a + lang → verdict 完整对象 or null */
export function extract(project, a, lang = 'zh') {
  if (!a) return null;
  try {
    // 重建 alpha — 与 App.jsx DetailPanel 的逻辑一致
    const cgFdvRaw   = safeNum(project?.cgData?.market_data?.fully_diluted_valuation?.usd);
    const totalFund  = safeNum(project?.details?.total_funding) || 0;
    const cgFdvValid = cgFdvRaw && cgFdvRaw > totalFund * 0.5;
    const cgFdv      = cgFdvValid ? cgFdvRaw : null;
    const lastRound  = project?.fundingRounds?.[0];
    const roundVal   = safeNum(lastRound?.valuation) || 0;
    const roundAmt   = safeNum(lastRound?.amount) || 0;
    const impliedVal = roundVal > 0 ? roundVal : roundAmt > 0 ? roundAmt / 0.25 : totalFund;
    const entryVal   = cgFdv || impliedVal;
    const irrData    = calcIRR(entryVal, a?.fair_value_usd);
    const alpha      = alphaScore(safeNum(a?.composite) || 0, irrData, safeNum(a?.risk_penalty) || 0);
    return computeVerdict(project, a, alpha, lang);
  } catch {
    return null;
  }
}
